import React from 'react';
import { Card, Button, Avatar } from 'antd';
import { StarFilled } from '@ant-design/icons';
import s from './s.module.less';
import startedIcon from 'assets/common/stared.svg';

type IProps = {
    showNumber?: number;
};

const providers = [
    {
        avatar:
      'https://cdn.helloklarity.net/provider/image/profile/400x/040a5512-54e5-408a-8ee3-c636446751f7.jpeg',
        name: 'Derek Timbs, FNP-BC',
        specialty: 'Specialize in Weight Loss, Preventive Medicine',
        rating: 4.98,
        profileUrl:
      'https://www.helloklarity.com/provider/derek-timbs?state=texas&condition=weight-loss',
    },
    {
        avatar:
      'https://cdn.helloklarity.net/provider/image/profile/400x/8ab4255a-833d-4c92-9fa2-7d7da52c70f4.png',
        name: 'Kelly Cobb, PMHNP-BC',
        specialty: 'Specialize in Psychiatry',
        rating: 5.0,
        profileUrl:
      'https://www.helloklarity.com/provider/kelly-cobb?state=florida&condition=adhd',
    },
    {
        avatar:
      'https://cdn.helloklarity.net/provider/image/profile/400x/60872f3e-afa7-49e5-84ae-a7539f5778fb.png',
        name: 'Milka Galvez, PMHNP-BC',
        specialty: 'Specialize in Mental Health, Psychiatry',
        rating: 5.0,
        profileUrl:
      'https://www.helloklarity.com/provider/milka-galvez?state=california&condition=anxiety',
    },
];

const ProviderShowcase = ({ showNumber = 3 }: IProps) => {
    return (
        <div className={s.providerList}>
            {providers.slice(0, showNumber).map((p, idx) => (
                <div key={idx} className={s.providerCard}>
                    <div className={s.providerCardContent}>
                        <div className={s.avatarContainer}>
                            <Avatar src={p.avatar} size={48} className={s.avatar} />
                            <div className={s.rating}>
                                <img src={startedIcon} className={s.starIcon} />
                                <span className={s.ratingValue}>{p.rating}</span>
                            </div>
                        </div>
                        <div className={s.providerInfo}>
                            <div className={s.providerName}>{p.name}</div>
                            <div className={s.specialty}>{p.specialty}</div>
                        </div>
                    </div>
                    <Button
                        block
                        className={s.viewProfileButton}
                        onClick={() => {
                            window.open(p.profileUrl, '_blank');
                        }}
                    >
                        View profile
                    </Button>
                </div>
            ))}
        </div>
    );
};

export default ProviderShowcase;
